// Role-based configuration for navigation and routing

export const ROLES = {
  SUPERVISOR: "Supervisor",
  TECHNICIAN: "Technician",
  PLANT_DIRECTOR: "PlantDirector",
};

// Default dashboard route per role
export const roleDashboardMap = {
  [ROLES.SUPERVISOR]: "/dashboard",
  [ROLES.TECHNICIAN]: "/technician_dashboard",
  [ROLES.PLANT_DIRECTOR]: "/dashboard",
};

// Navigation items per role
export const roleNavigationMap = {
  [ROLES.SUPERVISOR]: [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Work Orders", path: "/work-orders" },
    { label: "Requests", path: "/requests" },
  ],
  [ROLES.TECHNICIAN]: [
    { label: "Dashboard", path: "/dashboard" },
  ],
  [ROLES.PLANT_DIRECTOR]: [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Assets", path: "/assets" },
    { label: "Work Orders", path: "/work-orders" },
    { label: "Requests", path: "/requests" },
  ],
};

// Get the default dashboard for a role
export const getDefaultDashboard = (role) => {
  return roleDashboardMap[role] || "/dashboard";
};

// Allowed routes per role (includes sub-routes)
export const roleAllowedRoutes = {
  [ROLES.SUPERVISOR]: ["/dashboard", "/work-orders", "/requests"],
  [ROLES.TECHNICIAN]: ["/dashboard", "/asset"],
  [ROLES.PLANT_DIRECTOR]: ["/dashboard", "/assets", "/asset", "/work-orders", "/requests"],
};

// Check if a role can access a given path
export const canAccessRoute = (role, pathname) => {
  const allowed = roleAllowedRoutes[role];
  if (!allowed) return false;
  return allowed.some(
    (route) => pathname === route || pathname.startsWith(route + "/"),
  );
};

// Get navigation items for a role
export const getNavigationItems = (role) => {
  return roleNavigationMap[role] || roleNavigationMap[ROLES.TECHNICIAN];
};
